<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectGradeCodes" });
import TagList from "../../../../selects/tag-list/TagList.svelte";
import { GRADES } from "../../config/grades.js";
import { t } from "svelte-i18n";
export let keys = [];
export let name = "grade-codes";
export let label = "resource.auction.properties.grade.code.label";
export let isDisabled = false;
export let minItems = 0;
export let maxItems = 1e3;
$: options = GRADES.filter((option) => !option.isLegacy).map((option) => ({
    ...option,
    label: $t(option.label)
}));
</script>


{#if Array.isArray(keys) }
    {#if Array.isArray(options) && options.length > 0 }

        <TagList
            bind:keys
            { name }
            { options }
            { label }
            { minItems }
            { maxItems }
            { isDisabled }
            mode = 'toggle'
        />

    {/if}
{/if}